import React, { Fragment, useEffect, useState } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { submitDnataTest } from "../../redux/actions/dnataActions";
import Timer from "./Timer";
import styles from "./styles.scss";

const Test = ({ appData, submitDnataTestFunc }) => {
  const [started, setStarted] = useState(false);
  const [counter, setCounter] = useState({
    min: 19,
    sec: 59,
  });

  let initialData = {};
  if (appData.dnataOnboarding && appData.dnataOnboarding.test) {
    initialData = {
      ...initialData,
      ...appData.dnataOnboarding.test,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const timerCSS = {
    position: "fixed",
    backgroundColor: "white",
    display: "flex",
    width: "80px",
    height: "40px",
    bottom: "0",
    right: "0",
    color: "black",
    fontWeight: "bold",
    fontSize: "15px",
    alignItems: "center",
    justifyContent: "center",
    border: "3px solid orange",
  };

  const style = {
    display: "flex",
    width: "100%",
    alignItems: "center",
    // justifyContent: "space-between",
  };

  const getVal = getField(initialData);
  const initialState = {
    section1: {
      htmlObj: (
        <div>
          <HorizontalLine text={"SECTION 1"} />
          <p>
            Read the following bullet points and answer the two questions below.
            You can only select one answer per question.
          </p>
          <p>
            There is only <b>ONE</b> answer for each question.
          </p>
          <div>
            <b>
              • The Fire Alarm is continuous ring of a bell. This means a Fire
              evacuation.
            </b>
            <br />
            <b>• When it sounds go to your fire assembly point.</b>
            <br />
            <b>
              • Remain there throughout the fire evacuation until told it is
              safe to re-enter the building by the Fire Marshall / Fire Officer.
            </b>
            <br />
          </div>
        </div>
      ),
    },
    q1: {
      htmlObj: <div>Question 1</div>,
    },
    Group1: {
      title: "What should you do when you hear a continuous ring of a bell?",
      type: "radio",
      radioOptions: [
        "Wait for your supervisor to tell you what to do",
        "Go to your Fire Assembly Area",
        "Ignore it",
      ],
      value: getVal("Group1"),
      seeAsterix: false,
    },
    q2: {
      htmlObj: <div>Question 2</div>,
    },
    Group2: {
      title:
        "In the event of a Fire Evacuation, when can you re-enter the building?",
      type: "radio",
      radioOptions: [
        "When it starts to rain",
        "When other members of staff re-enter the building",
        "When informed by the Fire Marshall / Fire Officer",
      ],
      value: getVal("Group2"),
      seeAsterix: false,
    },
    section2: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 2"} />
          <br />
          <div>Question 1</div>
          <br />
          What is the next number?
        </Fragment>
      ),
    },
    nextNumber1: {
      title: "5124890",
      type: "text",
      value: getVal("nextNumber1"),
      style,
      inputWidth: "200px",
    },
    nextNumber2: {
      title: "2.3393245",
      type: "text",
      value: getVal("nextNumber2"),
      style,
      inputWidth: "200px",
    },
    nextNumber3: {
      title: "55000",
      type: "text",
      value: getVal("nextNumber3"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    nextNumber4: {
      title: "69431",
      type: "text",
      value: getVal("nextNumber4"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    blurbSection2: {
      htmlObj: (
        <Fragment>
          <br />
          <div>Question 2</div>
          <br />
          What is the previous number?
        </Fragment>
      ),
    },
    prevNumber1: {
      title: "4401157",
      type: "text",
      value: getVal("prevNumber1"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    prevNumber2: {
      title: "54199",
      type: "text",
      value: getVal("prevNumber2"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    prevNumber3: {
      title: "6139067",
      type: "text",
      value: getVal("prevNumber3"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    prevNumber4: {
      title: "2800",
      type: "text",
      value: getVal("prevNumber4"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    q3: {
      htmlObj: (
        <div>
          <br />
          Question 3
        </div>
      ),
    },
    Group3: {
      title:
        "Today is Monday 3rd August 2019. It is 3 pm. Which of the these is correct?",
      type: "radio",
      radioOptions: [
        "05/09/19  15:00 hours",
        "03/08/19  15:00 hours",
        "03/08/19  19:00 hours",
      ],
      value: getVal("Group3"),
      seeAsterix: false,
    },
    section3: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 3"} />
          <br />
          <div>
            Answer the questions below. You may use a calculator or phone.
          </div>
        </Fragment>
      ),
    },
    calculations1: {
      title: "33 - 9 =",
      type: "text",
      value: getVal("calculations1"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    calculations2: {
      title: "128 x 4 =",
      type: "text",
      value: getVal("calculations2"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    calculations3: {
      title: "79 + 82 =",
      type: "text",
      value: getVal("calculations3"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    calculations4: {
      title: "147 - 89 =",
      type: "text",
      value: getVal("calculations4"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    calculations5: {
      title: "124 x 12 =",
      type: "text",
      value: getVal("calculations5"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    calculations6: {
      title: "67 + 152 =",
      type: "text",
      value: getVal("calculations6"),
      seeAsterix: false,
      style,
      inputWidth: "200px",
    },
    section4: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"SECTION 4"} />
          <br />
          Find two codes which are the same in each row and select the value
          below.
          <br />
          <table style={{ width: "100%" }} id="simple-board">
            <tbody id="dnatatable">
              <tr id="row0">
                <td className={style.dnatarow} id="cell0-0"></td>
                <td className={style.dnatarow} id="cell0-1">
                  A
                </td>
                <td className={style.dnatarow} id="cell0-2">
                  B
                </td>
                <td className={style.dnatarow} id="cell0-3">
                  C
                </td>
                <td className={style.dnatarow} id="cell0-4">
                  D
                </td>
                <td className={style.dnatarow} id="cell0-5">
                  E
                </td>
              </tr>
              <tr id="row1">
                <td className={style.dnatarow} id="cell1-0">
                  1
                </td>
                <td className={style.dnatarow} id="cell1-1">
                  6522
                </td>
                <td className={style.dnatarow} id="cell1-2">
                  5262
                </td>
                <td className={style.dnatarow} id="cell1-3">
                  6252
                </td>
                <td className={style.dnatarow} id="cell1-4">
                  6522
                </td>
                <td className={style.dnatarow} id="cell1-5">
                  6225
                </td>
              </tr>
              <tr id="row2">
                <td className={style.dnatarow} id="cell2-0">
                  2
                </td>
                <td className={style.dnatarow} id="cell2-1">
                  SSGB
                </td>
                <td className={style.dnatarow} id="cell2-2">
                  SGSB
                </td>
                <td className={style.dnatarow} id="cell2-3">
                  SSBG
                </td>
                <td className={style.dnatarow} id="cell2-4">
                  GBSS
                </td>
                <td className={style.dnatarow} id="cell2-5">
                  SSBG
                </td>
              </tr>
              <tr id="row3">
                <td className={style.dnatarow} id="cell3-0">
                  3
                </td>
                <td className={style.dnatarow} id="cell3-1">
                  8553
                </td>
                <td className={style.dnatarow} id="cell3-2">
                  8535
                </td>
                <td className={style.dnatarow} id="cell3-3">
                  5852
                </td>
                <td className={style.dnatarow} id="cell3-4">
                  8535
                </td>
                <td className={style.dnatarow} id="cell3-5">
                  8355
                </td>
              </tr>
              <tr id="row4">
                <td className={style.dnatarow} id="cell4-0">
                  4
                </td>
                <td className={style.dnatarow} id="cell4-1">
                  YWHN
                </td>
                <td className={style.dnatarow} id="cell4-2">
                  YHWN
                </td>
                <td className={style.dnatarow} id="cell4-3">
                  YWHN
                </td>
                <td className={style.dnatarow} id="cell4-4">
                  YNWH
                </td>
                <td className={style.dnatarow} id="cell4-5">
                  NYW
                </td>
              </tr>
              <tr id="row5">
                <td className={style.dnatarow} id="cell5-0">
                  5
                </td>
                <td className={style.dnatarow} id="cell5-1">
                  57657
                </td>
                <td className={style.dnatarow} id="cell5-2">
                  57675
                </td>
                <td className={style.dnatarow} id="cell5-3">
                  57675
                </td>
                <td className={style.dnatarow} id="cell5-4">
                  56675
                </td>
                <td className={style.dnatarow} id="cell5-5">
                  57765
                </td>
              </tr>
              <tr id="row6">
                <td className={style.dnatarow} id="cell6-0">
                  6
                </td>
                <td className={style.dnatarow} id="cell6-1">
                  ZHHCZ
                </td>
                <td className={style.dnatarow} id="cell6-2">
                  ZZCHH
                </td>
                <td className={style.dnatarow} id="cell6-3">
                  ZCHHZ
                </td>
                <td className={style.dnatarow} id="cell6-4">
                  ZCZHH
                </td>
                <td className={style.dnatarow} id="cell6-5">
                  ZCHH
                </td>
              </tr>
              <tr id="row7">
                <td className={style.dnatarow} id="cell7-0">
                  7
                </td>
                <td className={style.dnatarow} id="cell7-1">
                  82443
                </td>
                <td className={style.dnatarow} id="cell7-2">
                  84243
                </td>
                <td className={style.dnatarow} id="cell7-3">
                  84234
                </td>
                <td className={style.dnatarow} id="cell7-4">
                  84342
                </td>
                <td className={style.dnatarow} id="cell7-5">
                  84243
                </td>
              </tr>
            </tbody>
          </table>
        </Fragment>
      ),
    },
    row1: {
      title: "Row 1:",
      value: getVal("row1"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "6522", value: "6522" },
        { label: "5262", value: "5262" },
        { label: "6252", value: "6252" },
        { label: "6225", value: "6225" },
      ],
    },
    row2: {
      title: "Row 2:",
      value: getVal("row2"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "SSGB", value: "SSGB" },
        { label: "SGSB", value: "SGSB" },
        { label: "SSBG", value: "SSBG" },
        { label: "GBSS", value: "GBSS" },
      ],
    },
    row3: {
      title: "Row 3:",
      value: getVal("row3"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "8553", value: "8553" },
        { label: "8535", value: "8535" },
        { label: "5852", value: "5852" },
        { label: "8355", value: "8355" },
      ],
    },
    row4: {
      title: "Row 4:",
      value: getVal("row4"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "YWHN", value: "YWHN" },
        { label: "YHWN", value: "YHWN" },
        { label: "YNWH", value: "YNWH" },
        { label: "NYW", value: "NYW" },
      ],
    },
    row5: {
      title: "Row 5:",
      value: getVal("row5"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "57657", value: "57657" },
        { label: "57675", value: "57675" },
        { label: "56675", value: "56675" },
        { label: "57765", value: "57765" },
      ],
    },
    row6: {
      title: "Row 6:",
      value: getVal("row6"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "ZHHCZ", value: "ZHHCZ" },
        { label: "ZZCHH", value: "ZZCHH" },
        { label: "ZCHHZ", value: "ZCHHZ" },
        { label: "ZCZHH", value: "ZCZHH" },
        { label: "ZCHH", value: "ZCHH" },
      ],
    },
    row7: {
      title: "Row 7:",
      value: getVal("row7"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "82443", value: "82443" },
        { label: "84243", value: "84243" },
        { label: "84234", value: "84234" },
        { label: "84342", value: "84342" },
      ],
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitDnataTestFunc({
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/dnata-onboarding");
  };

  useEffect(() => {
    if (appData.dnataOnboarding && appData.dnataOnboarding.testCompleted) {
      history.push("/profile/edit/dnata-onboarding");
    }
    if (counter.min === 0 && counter.sec === 0) {
      handleSubmit();
    }
  }, [counter]);

  return !started ? (
    <div className="container d-flex flex-column align-items-center justify-content-center pt-2">
      <h2 style={{ padding: "0 1rem" }}>Operations Recruitment Test</h2>
      <p style={{ padding: "1rem" }}>
        You have 20 minutes for the test.
        <br />
        The timer will be visible to you throughout the test in the bottom right
        corner.
        <br /> When you are ready please press Start button. <br />
        You can only complete the test once.
      </p>
      <button
        className="btn btn-primary"
        style={{ width: "280px", margin: "1rem 0" }}
        onClick={() => setStarted(true)}
      >
        Start
      </button>
    </div>
  ) : (
    <Fragment>
      <FormCreator
        formTitle={"Operations Recruitment Test"}
        fields={fields}
        setField={setField}
        handleSubmit={handleSubmit}
        handleCancel={() => history.push("/profile/edit/dnata-onboarding")}
        onboardingBranch={"dnata"}
        helper=""
      />
      <div style={timerCSS}>
        <Timer
          counter={counter}
          setCounter={setCounter}
          timeLimitInMinutes={20}
        />
      </div>
    </Fragment>
  );
};

Test.propTypes = {
  submitDnataTestFunc: func,
  appData: any,
};
const mapDispatchToProps = {
  submitDnataTestFunc: submitDnataTest,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(Test);
